export default __webpack_public_path__ + "static/media/WM0500.34I-43534_-26027_0.86710131.jpg";